var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoho(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240,
    height: 120,
    viewBox: "0 0 240 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.014,
    x2: 0.5,
    y2: 0.97,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#ffe513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdb924"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.045,
    y1: 0.135,
    x2: 0.957,
    y2: 0.871,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#008cd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00649d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 0.278,
    x2: 0.5,
    y2: 0.975,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#26a146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008a52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.437,
    y1: 0.082,
    x2: 0.575,
    y2: 0.932,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d92231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ba2234"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-_84"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 120
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_84",
    "data-name": 84,
    clipPath: "url(#clip-_84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "zoho-1",
    transform: "translate(48 35.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115386",
    "data-name": "Path 115386",
    d: "M499.925,37.7V71.844L495.2,76.456V43.044Z",
    transform: "translate(-355.925 -27.097)",
    fill: "#e79225"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115387",
    "data-name": "Path 115387",
    d: "M389.394,37.728,384.5,43.044l.253.338,30.684-.113.281-.225,4.641-5.344-30.966.028Z",
    transform: "translate(-276.359 -27.097)",
    fill: "#fff16d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115388",
    "data-name": "Path 115388",
    d: "M.5,19.7H31.719V53.141H.5Z",
    transform: "translate(107.641 -3.753)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115389",
    "data-name": "Path 115389",
    d: "M418.369,79.734a12.366,12.366,0,0,0-2.756-4.162A11.41,11.41,0,0,0,411.7,72.9a12.115,12.115,0,0,0-4.669-.9,12.257,12.257,0,0,0-4.7.9,11.409,11.409,0,0,0-3.909,2.672,12.287,12.287,0,0,0-2.728,4.162,13.547,13.547,0,0,0-.9,5.091,13.72,13.72,0,0,0,.928,5.063,12.514,12.514,0,0,0,2.728,4.219,11.429,11.429,0,0,0,3.853,2.616,12.441,12.441,0,0,0,4.753.9,12.076,12.076,0,0,0,4.641-.9,11.936,11.936,0,0,0,3.909-2.616,12.763,12.763,0,0,0,2.756-4.191,14.424,14.424,0,0,0,0-10.181Zm-6.441,11.025a6.644,6.644,0,0,1-9.816,0,8.986,8.986,0,0,1-1.8-5.962,9.337,9.337,0,0,1,1.8-6.047,5.979,5.979,0,0,1,4.922-2.166,6.042,6.042,0,0,1,4.894,2.166,9.336,9.336,0,0,1,1.8,6.047A8.986,8.986,0,0,1,411.928,90.759Z",
    transform: "translate(-283.762 -51.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_68758",
    "data-name": "Group 68758",
    transform: "translate(72.366 7.819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115390",
    "data-name": "Path 115390",
    d: "M366.556,27.8v.169l3.994,30.684-2.334,6.469-.309-.225L363.8,35.478l.084-.394,2.559-7.116Z",
    transform: "translate(-333.847 -27.8)",
    fill: "#009ada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115391",
    "data-name": "Path 115391",
    d: "M261.856,32.075,292.6,27.8l-2.588,7.369-.366.394L260.9,39.781l.141-5.259.816-2.447Z",
    transform: "translate(-259.887 -27.8)",
    fill: "#91c9ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115392",
    "data-name": "Path 115392",
    d: "M30.422,27l4.247,29.953L4.378,61.2.3,32.259l1.772-1.378Z",
    transform: "translate(-0.3 -19.631)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115393",
    "data-name": "Path 115393",
    d: "M297.944,67.572a3.521,3.521,0,0,0-.956-2.109,2.253,2.253,0,0,0-1.519-.562,2.892,2.892,0,0,0-.478.028A2.334,2.334,0,0,0,293.247,66a2.792,2.792,0,0,0-.394,1.575,6.93,6.93,0,0,0,.056.731l1.1,7.791-8.719,1.294-1.1-7.791a3.516,3.516,0,0,0-.956-2.081,2.321,2.321,0,0,0-1.913-.562,2.5,2.5,0,0,0-1.828,1.069A2.792,2.792,0,0,0,279.1,69.6c0,.225.028.478.056.759l2.981,20.278a3.266,3.266,0,0,0,1.012,2.109,2.253,2.253,0,0,0,1.547.534,3.057,3.057,0,0,0,.506-.028,2.278,2.278,0,0,0,1.688-1.069,2.9,2.9,0,0,0,.366-1.519,6.922,6.922,0,0,0-.056-.731l-1.209-8.016,8.719-1.294,1.209,8.016a3.236,3.236,0,0,0,.984,2.081,2.253,2.253,0,0,0,1.519.563,2.892,2.892,0,0,0,.478-.028,2.334,2.334,0,0,0,1.744-1.069,2.935,2.935,0,0,0,.394-1.547,6.922,6.922,0,0,0-.056-.731l-3.037-20.334Z",
    transform: "translate(-272.969 -54.466)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68759",
    "data-name": "Group 68759",
    transform: "translate(34.622)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115394",
    "data-name": "Path 115394",
    d: "M134.041,0,123.1,25.988l1.491,11.419.084-.028L136.966,9.731l-.056-.591L134.266.366Z",
    transform: "translate(-123.1)",
    fill: "#66bf6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115395",
    "data-name": "Path 115395",
    d: "M162,0l2.841,9.534.056.2,27.056,12.122.084-.056-2.306-9.113Z",
    transform: "translate(-151.059)",
    fill: "#98d0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115396",
    "data-name": "Path 115396",
    d: "M17.691,33.9l27.2,12.262L32.6,74.034,5.4,61.772,17.691,33.9Z",
    transform: "translate(-3.909 -24.366)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115397",
    "data-name": "Path 115397",
    d: "M178.406,65.878a11.8,11.8,0,0,0-2.475-4.05,11.9,11.9,0,0,0-8.466-3.628h-.084a11.36,11.36,0,0,0-4.641,1.041,12.408,12.408,0,0,0-4.163,2.925,14.682,14.682,0,0,0-2.869,4.5,15.058,15.058,0,0,0-1.209,5.175v.591a12.921,12.921,0,0,0,.788,4.472,11.865,11.865,0,0,0,10.969,7.622h.028a11.729,11.729,0,0,0,4.613-.984,12.6,12.6,0,0,0,4.191-2.953,14.607,14.607,0,0,0,2.9-4.472,15.207,15.207,0,0,0,1.209-5.175v-.506a12.157,12.157,0,0,0-.788-4.556Zm-5.428,8.1a9.6,9.6,0,0,1-4.05,4.978,5.86,5.86,0,0,1-2.756.731,6.689,6.689,0,0,1-2.559-.562,5.817,5.817,0,0,1-3.6-3.966,7.343,7.343,0,0,1-.253-1.941,11.568,11.568,0,0,1,1.012-4.444,9.97,9.97,0,0,1,4.078-5.091,5.548,5.548,0,0,1,2.756-.731,6.823,6.823,0,0,1,2.587.563,5.839,5.839,0,0,1,3.572,3.966,6.985,6.985,0,0,1,.253,1.913A11.77,11.77,0,0,1,172.978,73.978Z",
    transform: "translate(-145.669 -41.831)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68760",
    "data-name": "Group 68760",
    transform: "translate(0 4.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115398",
    "data-name": "Path 115398",
    d: "M109.794,15.7l4.444,29.756-2.025,10.463-.281-.366L107.6,26.809v-.562l1.912-10.041.281-.506Z",
    transform: "translate(-77.338 -15.7)",
    fill: "#760d16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115399",
    "data-name": "Path 115399",
    d: "M0,31.084,2.109,20.566,32.456,15.7,30.4,26.416v.7L.366,31.366Z",
    transform: "translate(0 -15.7)",
    fill: "#ef463e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115400",
    "data-name": "Path 115400",
    d: "M30.4,38.8l4.472,29.5L4.838,73,0,43.469Z",
    transform: "translate(0 -28.084)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115401",
    "data-name": "Path 115401",
    d: "M45.856,87.95a2.1,2.1,0,0,0-.956-.619,4.379,4.379,0,0,0-1.463-.2,11.314,11.314,0,0,0-1.828.169l-7.931,1.35a7.524,7.524,0,0,1,.928-2.391,32.029,32.029,0,0,1,2.644-3.937c.394-.534.7-.928.928-1.209.141-.2.366-.45.647-.816A19.692,19.692,0,0,0,42.2,74.45a12.137,12.137,0,0,0,.45-2.616,6.118,6.118,0,0,0,.028-.7,10.357,10.357,0,0,0-.169-1.856,4.2,4.2,0,0,0-.422-1.378,2.036,2.036,0,0,0-.7-.816,2.653,2.653,0,0,0-1.378-.281,11.551,11.551,0,0,0-1.772.169l-9.169,1.575a4.6,4.6,0,0,0-2.447,1.012A1.935,1.935,0,0,0,26,71.019a2.892,2.892,0,0,0,.028.478,2.042,2.042,0,0,0,1.181,1.631,3.492,3.492,0,0,0,1.406.253,6.731,6.731,0,0,0,1.238-.113l7.65-1.35c0,.141.028.281.028.394a4.01,4.01,0,0,1-.253,1.406,10.283,10.283,0,0,1-1.716,2.7c-.253.309-.647.816-1.181,1.462a36.155,36.155,0,0,0-4.444,6.413,13.848,13.848,0,0,0-1.322,3.628,10.1,10.1,0,0,0-.225,2,6.8,6.8,0,0,0,.112,1.322,5.755,5.755,0,0,0,.45,1.519,2,2,0,0,0,.787.872,2.849,2.849,0,0,0,1.35.225,19.775,19.775,0,0,0,3.122-.338l8.325-1.434a7.026,7.026,0,0,0,3.094-1.1,1.946,1.946,0,0,0,.731-1.547,3.1,3.1,0,0,0-.056-.506A1.864,1.864,0,0,0,45.856,87.95Z",
    transform: "translate(-18.688 -52.428)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoho);
export default __webpack_public_path__ + "static/media/zoho.d7d1e64a700a6c0a3c3e8f8ab5e53bb2.svg";
export { ForwardRef as ReactComponent };